import { FormField, MaskedInput } from 'grommet';
import { validatePhoneNumberLength } from '@services/phoneNumberService';
import { phoneMask } from '@utils/masks';
import type { PhoneProps } from '@customTypes/types';

export const Phone = (props: PhoneProps): JSX.Element => {
  return (
    <FormField
      name="phone"
      htmlFor="phone"
      label="Phone"
      validate={(value) => validatePhoneNumberLength(value)}
      required
    >
      <MaskedInput
        id="phone"
        name="phone"
        mask={phoneMask}
        value={props.phoneNumber}
        onChange={({ target }) => props.onPhoneNumberChange(target.value)}
      />
    </FormField>
  );
};
